import * as Sentry from "@sentry/react-native";

//  This is needed to communicate between the integration and React
export const routingInstrumentation = Sentry.reactNavigationIntegration();
